/**
 * @returns {Object}
 */
export function notGreaterThan() {
    
    return {
        require: 'ngModel',
        link: (scope, element, attr, ctrl) => {
            
            const validate = (value) => {
                
                const comparisonModel = attr.notGreaterThan;
                
                if (!value || !comparisonModel) {
                    
                    ctrl.$setValidity('notGreaterThan', true);
                    
                } else {
                    
                    ctrl.$setValidity('notGreaterThan', parseFloat(value) <= parseFloat(comparisonModel));
                }
                
                return value;
            };
            
            ctrl.$parsers.unshift(validate);
            ctrl.$formatters.push(validate);
            
            attr.$observe('notGreaterThan', (comparisonModel) => {
                
                return validate(ctrl.$viewValue);
            });
        }
    };
}


// WEBPACK FOOTER //
// ./src/ui/directives/not-greater-than.directive.js